module.exports = __webpack_public_path__ + "static/media/Slide60.fb3eaa2d.JPG";